import type { Components, Theme } from "@mui/material/styles";

const severityColorMap = {
    success: {
        backgroundColor: "var(--mui-palette-green-600)",
        color: "var(--mui-palette-common-white)",
    },
    error: {
        backgroundColor: "var(--mui-palette-red-600)",
        color: "var(--mui-palette-common-white)",
    },
    warning: {
        backgroundColor: "var(--mui-palette-orange-600)",
        color: "var(--mui-palette-common-white)",
    },
    info: {
        backgroundColor: "var(--mui-palette-gray-800)",
        color: "var(--mui-palette-common-white)",
    },
};

export const MuiAlert: Components<Theme>["MuiAlert"] = {
    defaultProps: {
        variant: "filled",
        severity: "success",
    },
    styleOverrides: {
        root: {
            borderRadius: "8px",
            padding: "16px",
            alignItems: "center",

            variants: Object.entries(severityColorMap).map(([severity, style]) => ({
                props: { variant: "filled" as const, severity: severity as keyof typeof severityColorMap },
                style,
            })),
        },
        icon: {
            marginRight: "8px",
            padding: 0,
            opacity: 1,
            fontSize: "24px",
            alignSelf: "flex-start",
        },
        message: {
            padding: 0,
            flexGrow: 1,
        },
        action: {
            padding: 0,
            marginLeft: 0,
            marginRight: 0,
            alignItems: "center",
        },
    },
};

export const MuiAlertTitle: Components<Theme>["MuiAlertTitle"] = {
    styleOverrides: {
        root: {
            margin: 0,
            marginRight: "16px",
            fontSize: "16px",
            lineHeight: "24px",
            fontWeight: 600,
        },
    },
};
